import MobileMenu from "./modules/MobileMenu";

function init() {
  const item = document.querySelector('.header-btn-collapse-nav');
  if (item instanceof HTMLElement) {
    new MobileMenu(item);
  }
}

window.addEventListener('load', init, false);
